export const E2EE_ALG = 'A1';
export const E2EE_KEY_BYTES = 32;
export const E2EE_NONCE_BYTES = 12;
